import axios from 'axios';
import {
  HOME_LOAD_PAGES_BEGIN,
  HOME_LOAD_PAGES_DISMISS_ERROR,
  HOME_LOAD_PAGES_FAILURE,
  HOME_LOAD_PAGES_SUCCESS,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadPages(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_LOAD_PAGES_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${projectId}/project`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_LOAD_PAGES_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_LOAD_PAGES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadPagesError() {
  return {
    type: HOME_LOAD_PAGES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_LOAD_PAGES_BEGIN:
      return {
        ...state,
        loadPagesPending: true,
        loadPagesError: null,
      };

    case HOME_LOAD_PAGES_SUCCESS:
      return {
        ...state,
        loadPagesPending: false,
        loadPagesError: null,
        pages: action.data,
        //selectedPage: action.data[0],
      };

    case HOME_LOAD_PAGES_FAILURE:
      return {
        ...state,
        loadPagesPending: false,
        loadPagesError: action.data.error,
      };

    case HOME_LOAD_PAGES_DISMISS_ERROR:
      return {
        ...state,
        loadPagesError: null,
      };

    default:
      return state;
  }
}
